import User from "../DTO/User";
import {Investment} from "../DTO/Investment";

export function calculateUserTotalInvestments(user: User, projectCode: string) {
    const projectInvestments: Investment[] = user.investments.filter(inv => inv.project.code === projectCode);

    return projectInvestments.reduce((total, inv) => total + inv.amount, 0);
}